module.exports = __webpack_public_path__ + "static/media/banner.9d95b9c9.jpg";